module.exports = __webpack_public_path__ + "img/SMT_35_Ms_Eunice_Wong.09b9963e.jpg";